var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<fieldset style=\"padding: 0 16px 16px 16px\"> <legend ng-i18next>reservation_customer.extra_info</legend> <textarea class=\"form-control\" rows=\"3\" style=\"resize: none\" ng-model=\"$ctrl.data.MessageToBooking\" ng-model-options=\"{ updateOn: 'blur' }\" placeholder=\"{{'reservation_customer.write_here' |i18next}}\"></textarea> <style type=\"text/css\"></style> </fieldset>";
var id1="winresMessageToBooking.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresMessageToBooking/winresMessageToBooking.html
// module id = 529
// module chunks = 2